export const removeSpaces = (str: string) => str.replace(/\s/g, '')
